import type { I18n } from '@lingui/core'
import type { VFC } from 'react'

import { CONTACT_LENS_GROUP_ID } from 'views/containers/browser/ProductVariantsAttributesContainer/consts'

import AttributePickerModalAndInfoButton from './AttributePickers/AttributePickerModalAndInfoButton'
import AttributePickerMultipleAttribute from './AttributePickers/AttributePickerMultipleAttribute'
import AttributePickerSelectAttribute from './AttributePickers/AttributePickerSelectAttribute'
import AttributePickerSingleAttribute from './AttributePickers/AttributePickerSingleAttribute'
import ExcludedAttributeValue from './AttributePickers/ExcludedAttributeValue'

import type {
  InStockFields,
  ProductAttributes,
  Variant,
  VariantAttribute,
} from './index'

interface AttributePickerProps {
  isSelected: boolean
  pickerValue: string | string[]
  isInStock: boolean
  isMasterPage?: boolean
  variant?: Variant
  isSingleAttributeProduct: boolean
  prescriptionType: string
  hasAdditionalCharge: boolean
  packageSizeAttribute: boolean
  variantAttribute: ProductAttributes
  selectedVariantAttributes: VariantAttribute[] | undefined
  i18n: I18n
  inStockFields: InStockFields
  hasUnitPricing: boolean
  selectedVariantUpid?: string
  selectedVariant?: Variant
}
export interface AttributePickers {
  pickerValue: string
  id: string
  styles: string
  packageSizeAttribute: boolean
  variantAttributeType: string
}
const AttributePicker: VFC<AttributePickerProps> = ({
  isSelected,
  pickerValue,
  isInStock,
  isMasterPage = false,
  variant,
  isSingleAttributeProduct,
  prescriptionType,
  hasAdditionalCharge,
  packageSizeAttribute,
  variantAttribute,
  selectedVariantAttributes,
  i18n,
  inStockFields,
  hasUnitPricing,
  selectedVariantUpid = '',
  selectedVariant,
}) => {
  let styles = 'o-ProductVariantsAttributePicker'
  if (isSelected && (!isMasterPage || !variantAttribute.personal)) {
    styles += ' selectedVariantAttribute'
  }
  if (!isInStock && !isMasterPage) {
    styles = styles + ' grayedOutVariantAttribute'
  }
  if (variantAttribute.type === 'LIST') {
    return variantAttribute.values[0].length > 1 ? (
      <AttributePickerSelectAttribute
        values={pickerValue as string[]}
        variantAttribute={variantAttribute}
        isMasterPage={isMasterPage}
        selectedVariantAttributes={selectedVariantAttributes}
        isPersonal={variantAttribute.personal}
        i18n={i18n}
        selectedVariant={selectedVariant}
        inStockFields={inStockFields}
        isSingleAttributeProduct={isSingleAttributeProduct}
        upid={isSingleAttributeProduct && selectedVariantUpid}
      />
    ) : (
      <div className="l-flex">
        <ExcludedAttributeValue
          attributeValue={pickerValue[0]}
          code={variantAttribute.code}
          attributeLabel={variantAttribute.label}
        />
        <div className="u-margin-small--left">
          {variantAttribute.groupId === CONTACT_LENS_GROUP_ID && (
            <AttributePickerModalAndInfoButton
              variantAttribute={variantAttribute}
              i18n={i18n}
              iconSize="small"
            />
          )}
        </div>
      </div>
    )
  }

  if (isSingleAttributeProduct) {
    return (
      <AttributePickerSingleAttribute
        pickerValue={pickerValue as string}
        id={variantAttribute.code}
        styles={styles}
        variant={variant}
        prescriptionType={prescriptionType}
        isSelected={isSelected}
        hasAdditionalCharge={hasAdditionalCharge}
        variantAttributeType={variantAttribute.type}
        packageSizeAttribute={packageSizeAttribute}
        hasUnitPricing={hasUnitPricing}
      />
    )
  } else {
    return (
      <AttributePickerMultipleAttribute
        pickerValue={pickerValue as string}
        id={variantAttribute.code}
        styles={styles}
        packageSizeAttribute={packageSizeAttribute}
        variantAttributeType={variantAttribute.type}
      />
    )
  }
}
export default AttributePicker
